import MedicalRecordDetail from './medical-record-detail';

export default MedicalRecordDetail;
